import React from 'react';
import styled from 'styled-components';

import {
  SectionHeader,
  SectionTitle,
} from '../../../components/TaskDescription';

import MarkdownContent from '@components/MarkdownContent';

const ContentSection = styled.div`
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`;

interface OutputSectionProps {
  output: string | null;
}

const OutputSection: React.FC<OutputSectionProps> = ({ output }) => {
  if (!output) {
    return null;
  }

  return (
    <ContentSection>
      <SectionHeader>
        <SectionTitle level={4} style={{ margin: 0 }}>
          Output
        </SectionTitle>
      </SectionHeader>
      <MarkdownContent content={output} />
    </ContentSection>
  );
};

export default OutputSection;
